import React from "react";
import { withStyles } from "@material-ui/core/styles";
import TimerOffOutlinedIcon from "@material-ui/icons/TimerOffOutlined";
import Tooltip from "../../../../../../common/StyledToolTip";
import { DRIVER_CLOCKED_IN_STATUS } from "../../../constants";
const styles = (theme) => ({
  root: {
    paddingTop: "8px",
  },
  icon: {
    fontSize: "12px",
    color: theme.rowViolationDotColor,
  },
});

const ClockedInStatusIndicator = (params) => {
  const { classes } = params;
  return (
    <div className={classes.root}>
      <Tooltip title={DRIVER_CLOCKED_IN_STATUS}>
        <TimerOffOutlinedIcon className={classes.icon} />
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(ClockedInStatusIndicator);
